var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLLetter = function SvgLLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 103 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l-letter_svg__a)",
    d: "M88.115 105.695c9.926 0 14.894 4.963 14.894 14.88v15.42H.659V.005H20.18c9.927 0 14.895 4.963 14.895 14.88v90.81z",
    className: "l-letter_svg__Vector"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "l-letter_svg__a",
    x1: -727.798,
    x2: 241.957,
    y1: -31.306,
    y2: 99.259,
    className: "l-letter_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })))));
};
export default SvgLLetter;